<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import type { PreviewMessageTheme } from '@/features/Bubble'
import { cn } from '@/lib/utils'

const props = defineProps<{
  previewMessageTheme?: PreviewMessageTheme
  onClick: () => void
}>()
const model = defineModel()
const closeButtonEl = ref()

const defaultBackgroundColor = '#FFF'
const defaultTextColor = '#303235'

onMounted(() => {
  useEventListener(closeButtonEl.value, 'click', (e) => {
    e.stopPropagation()
    props.onClick()
  })
})
</script>

<template>
  <button
    ref="closeButtonEl"
    part="preview-message-close-button"
    aria-label="Close"
    class="absolute top--2 right--2 rounded-full shadow-sm w-6 h-6 p-1 z-10 hover:brightness-95 active:brightness-90 transition-all border"
    :class="cn(model ? 'opacity-100' : 'opacity-0')"
    :style="`
      background-color: ${previewMessageTheme?.closeButtonBackgroundColor || defaultBackgroundColor};
      color: ${previewMessageTheme?.closeButtonIconColor || defaultTextColor};
    `"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</template>
